export class AppConstant {
  // HTTP status code.
  public static HTTP_STATUS_CODE_SUCCESS: string = '200';
  public static HTTP_STATUS_CODE_BAD_REQUEST: string = '400';
  public static HTTP_STATUS_CODE_UNAUTHORIZED: string = '401';
  public static HTTP_STATUS_CODE_FORBIDDEN: string = '403';
  public static HTTP_STATUS_CODE_NOT_FOUND: string = '404';
  public static HTTP_STATUS_CODE_INTERNAL_ERROR: string = '500';

  // HTTP method
  public static HTTP_METHOD_GET: string = 'GET';
  public static HTTP_METHOD_POST: string = 'POST';
  public static HTTP_METHOD_PUT: string = 'PUT';
  public static HTTP_METHOD_DELETE: string = 'DELETE';

  // UI NOTICE msg
  public static FETCH_DATA_ERROR: string =
    'Sorry, something went wrong. Please try again.';
  public static UPDATE_DATA_SUCCESS: string =
    'Your information has been submitted successfully.';
  public static UPDATE_DATA_ERROR: string =
    'An internal error occurred during your submit.';
   public static ARCHIVEFILE_SUCCESS: string =
    'Archive file was successfully';
    public static UPLOADFILE_SUCCESS: string =
    'Upload file was successfully';
    public static DELETE_SUCCESS: string =
    'Delete file was successfully';
    public static DELETE_COMPANY_CONFIG_SUCCESS: string =
    'ลบการตั้งค่าเสร็จเรียบร้อย';
}
